const InfoSecurity = () => {
  return (
    <section className="privacy-policy">
      <div className="container">
        <div className="common-title">
          <h2 className="common-title__h2">
            Политика информационной <span>безопасности</span>
          </h2>
          <p className="common-title__subtitle">
            всё о сохранности ваших денег 💸
          </p>
        </div>
        <div className="agreement-body">
          <p className="agreement-item">
            Оплатить заказ можно банковскими картами Visa, Master Card, «Мир»,
            «Юmoney». Чтобы оплатить покупку, вы будете перенаправлены на
            сайт платежной системы Unitpay/Юкасса, на котором нужно ввести
            необходимые данные. При оплате банковской картой и Юмани, безопасность
            платежей гарантирует процессинговый центр Unitpay/Юкасса.
          </p>
          <p className="agreement-item">
            Платежные системы Unitpay, Юкасса обладают подтвержденным
            сертификатом соответствия требованиям стандарта PCI DSS в части
            хранения, обработки и передачи данных держателей карт. Стандарт
            безопасности банковских карт PCI DSS поддерживается международными
            платежными системами, включая MasterCard и Visa, Inc. Система
            Unitpay также является участником программы непрерывного
            соответствия Compliance Control PCI DSS Compliance Process
            (P.D.C.P.).
          </p>
          <p className="agreement-item">
            Ваши конфиденциальные данные, необходимые для оплаты
            (реквизиты карты, регистрационные данные и др.), не поступают в
            интернет-магазин — их обработка производится на стороне
            процессингового центра Unitpay/Юкасса и полностью защищена.
          </p>
        </div>
      </div>
    </section>
  );
};

export default InfoSecurity;
